class StarRating
    constructor: (el) ->
        @.$el = el
        @.$stars = @.$el.querySelectorAll '.star-rating__star'

        @.rating = @.$el.dataset?.rating ? 0

        @.$el.classList.add 'star-rating--bound'
        @.Init()
        return

    Init: ->
        if @.rating > 0
            self = @
            index = 1
            @.$stars.forEach (starEl) ->
                if index <= self.rating
                    starEl.classList.add 'star-rating__star--active'
                index++
                return
        @.InitEvents()
        return

    InitEvents: ->
        self = @
        @.$stars.forEach (starEl) ->
            starEl.addEventListener 'mouseover', (e) ->
                starsArray = Array.from(self.$stars)
                hoverStarIndex = starsArray.indexOf(@)
                self.$stars.forEach (starCheckEl) ->
                    starCheckEl.classList.remove 'star-rating__star--premarked', 'star-rating__star--preunmarked'
                    if starsArray.indexOf(starCheckEl) <= hoverStarIndex
                        starCheckEl.classList.add 'star-rating__star--premarked'
                    else
                        starCheckEl.classList.add 'star-rating__star--preunmarked'
                    return
                return
            starEl.addEventListener 'mouseout', (e) ->
                self.$stars.forEach (starEl) ->
                    starEl.classList.remove 'star-rating__star--premarked', 'star-rating__star--preunmarked'
                    return
                return
            starEl.addEventListener 'click', (e) ->
                starsArray = Array.from(self.$stars)
                clickStarIndex = starsArray.indexOf(@)
                self.rating = clickStarIndex+1
                self.$el.dataset.rating = self.rating
                self.$stars.forEach (starCheckEl) ->
                    starCheckEl.classList.remove 'star-rating__star--premarked', 'star-rating__star--preunmarked', 'star-rating__star--active'
                    if starsArray.indexOf(starCheckEl) <= clickStarIndex
                        starCheckEl.classList.add 'star-rating__star--active'
                    return
                self.$el.dispatchEvent new CustomEvent 'star-rating-change', {
                    bubbles: false
                    detail: {
                        rating: self.rating
                    }
                }
                return
            return

        @.$el.addEventListener 'mouseout', (e) ->
            self.$stars.forEach (starEl) ->
                starEl.classList.remove 'star-rating__star--premarked', 'star-rating__star--preunmarked'
            return
        return

BindStarRatings = ->
    document.querySelectorAll '.star-rating:not(.star-rating--bound)'
        .forEach (el) ->
            new StarRating el
            return
    return

window.addEventListener 'bind-components', BindStarRatings

class StarRatingCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.bindLater = options?.bindLater ? false
        @.color = options?.color ? false
        @.disabled = options?.disabled ? false
        @.rating = options?.rating ? 0
        @.stars = options?.stars ? 1
        @.tag = options?.tag ? 'div'

        @.CreateElement()
        if !@.bindLater
            new StarRating @.$el
        return @.$el
    
    CreateElement: ->
        self = @
        @.$el = document.createElement @.tag
        @.$el.classList.add 'star-rating'
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        if @.color
            @.$el.classList.add "star-rating--#{ @.color }"
        if @.disabled
            @.$el.classList.add 'star-rating--disabled'
        [1..@.stars].forEach (star) ->
            starEl = document.createElement 'button'
            starEl.type = "button"
            starEl.classList.add 'star-rating__star'
            if star <= self.rating
                starEl.classList.add 'star-rating__star--active'
            starEl.innerHTML = "
                <span class='star-rating__star__icon icon-star'></span>
                <span class='star-rating__star__icon-marked icon-star-marked'></span>
            "
            self.$el.appendChild starEl
            return
        @.$el.dataset.rating = @.rating
        return

window.CreateStarRating = (options) ->
    return new StarRatingCreate options